var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewsecurityuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8813 3.43852L8.90691 6.32145C7.06913 6.98437 5.56696 9.08102 5.56696 10.9773V22.4319C5.56696 24.251 6.81347 26.6406 8.33163 27.7352L15.2033 32.6839C17.4566 34.3181 21.1641 34.3181 23.4174 32.6839L30.2891 27.7352C31.8072 26.6406 33.0537 24.251 33.0537 22.4319V10.9773C33.0537 9.08102 31.5515 6.98437 29.7138 6.32145L21.7394 3.43852C20.381 2.9606 18.2077 2.9606 16.8813 3.43852Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1348 17.4213C19.1668 17.4213 19.1987 17.4213 19.2307 17.4213H19.2627H19.2946C21.1324 17.3596 22.5707 15.9259 22.5867 14.1375C22.5867 12.3184 21.0525 10.8384 19.1668 10.8384C17.2811 10.8384 15.7469 12.3184 15.7469 14.1375C15.7789 15.9105 17.2171 17.3596 19.1348 17.4213Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7943 20.674C20.8607 19.4407 17.7284 19.4407 15.7788 20.674C14.8839 21.2599 14.3565 22.0923 14.3565 22.9557C14.3565 23.8344 14.8679 24.6361 15.7788 25.2219C16.7536 25.8386 18.0161 26.1624 19.2786 26.1624C20.541 26.1624 21.8195 25.854 22.7783 25.2219C23.6733 24.6361 24.2006 23.8036 24.2006 22.9403C24.2166 22.0615 23.7052 21.2599 22.7943 20.674Z",
    fill: "#EEEEEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewsecurityuser);
export default __webpack_public_path__ + "static/media/previewsecurityuser.93c6ffd01e6f56876ea23b2a0107e999.svg";
export { ForwardRef as ReactComponent };